import React from 'react';
import { X, Download } from 'lucide-react';
import { ref, getBlob } from 'firebase/storage';
import { storage } from '../../firebase';
import './ImageModal.css';

const ImageModal = ({ imageUrl, imageName, storagePath, onClose }) => {
  const [blobUrl, setBlobUrl] = React.useState(null);

  React.useEffect(() => {
    if (!imageUrl && !storagePath) return;
    let url = null;
    const load = async () => {
      if (storagePath) {
        try {
          const blob = await getBlob(ref(storage, storagePath));
          url = URL.createObjectURL(blob);
          setBlobUrl(url);
          return;
        } catch (e) {}
      }
      setBlobUrl(imageUrl);
    };
    load();
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [imageUrl, storagePath]);

  if (!imageUrl && !storagePath) return null;

  const handleDownload = async () => {
    const src = blobUrl || imageUrl;
    const link = document.createElement('a');
    link.href = src;
    link.download = imageName || 'image';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="image-modal-backdrop" onClick={handleBackdropClick}>
      <div className="image-modal-content">
        <div className="image-modal-header">
          <span className="image-modal-title">{imageName || 'Imagen'}</span>
          <div className="image-modal-actions">
            <button
              onClick={handleDownload}
              className="image-modal-btn"
              title="Descargar"
            >
              <Download size={20} />
            </button>
            <button
              onClick={onClose}
              className="image-modal-btn"
              title="Cerrar"
            >
              <X size={20} />
            </button>
          </div>
        </div>
        <div className="image-modal-body">
          <img
            src={blobUrl || imageUrl}
            alt={imageName || 'Preview'}
            className="image-modal-img"
          />
        </div>
      </div>
    </div>
  );
};

export default ImageModal;
